export const STATUS_OFF = 0;
export const STATUS_ON = 1;
export const STATUS_LOADING = 2;

export const VERTICAL = 'vertical';
export const HORIZONTAL = 'horizontal';

export const PANE_QUIZ_SIZE_DEFAULT = 300;
export const PANE_WORKSHEET_SIZE_DEFAULT = 500;

export const CHART_SIZE_DEFAULT = [500, 250];
export const CHART_SIZE_LARGE = [640, 320];
export const SYNCED_CHART_SIZE_DEFAULT = [500, 175];
